<div class="container">
  <h1 class="dialog-title">{{data.title}}</h1>
  <div class="dialog-content">
    <p [innerHTML]="data.text"></p>
  </div>
  <div class="dialog-actions">
    <lib-button-tertiary class="dialog-button" mat-dialog-close="true" cdkFocusInitial>{{data.okBtn ? data.okBtn : 'Ok'}}</lib-button-tertiary>
    <lib-button-primary class="dialog-button" *ngIf="data.cancelBtn != false" (click)="onNoClick()">{{data.cancelBtn ? data.cancelBtn : 'Cancelar'}}</lib-button-primary>    
  </div>
</div>